import {semanticColor} from "@khanacademy/wonder-blocks-tokens";

const KhanmigoFrontLogo = () => (
    <svg
        width="75"
        height="75"
        viewBox="0 13 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.24 13.34H39.83C42.70 13.34 45.02 15.67 45.02 18.53V42.02C45.02 44.29 42.32 45.47 40.66 43.93L38.91 42.31C38.43 41.86 37.80 41.61 37.14 41.61H15.65C14.21 41.61 13.05 40.45 13.05 39.02V18.53C13.05 15.67 15.38 13.34 18.24 13.34Z"
            fill="#DEAE93"
        />
        <circle
            cx="6.23284"
            cy="6.23284"
            r="6.23284"
            transform="matrix(1 0 0 -1 15.9492 35.084)"
            fill={semanticColor.core.foreground.knockout.default}
        />
        <mask
            id="mask0_5736_180435"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="14"
            height="14"
        >
            <circle
                cx="6.23284"
                cy="6.23284"
                r="6.23284"
                transform="matrix(1 0 0 -1 15.9492 35.084)"
                fill={semanticColor.core.foreground.knockout.default}
            />
        </mask>
        <g mask="url(#mask0_5736_180435)">
            <circle
                cx="3.98209"
                cy="3.98209"
                r="3.98209"
                transform="matrix(1 0 0 -1 18.1992 32.834)"
                fill="black"
            />
        </g>
        <circle
            cx="35.811"
            cy="28.852"
            r="6.23284"
            fill={semanticColor.core.foreground.knockout.default}
        />
        <mask
            id="mask1_5736_180435"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="29"
            y="22"
            width="14"
            height="14"
        >
            <circle
                cx="35.811"
                cy="28.852"
                r="6.23284"
                fill={semanticColor.core.foreground.knockout.default}
            />
        </mask>
        <g mask="url(#mask1_5736_180435)">
            <circle cx="35.8102" cy="28.8512" r="3.98209" fill="black" />
        </g>
    </svg>
);
export {KhanmigoFrontLogo};
